import { formatThousand } from '@/utils/util';
export const EchartOpt = () => ({
  // 图表沾满容器
  grid: {
    top: '5px',
    left: '0px',
    right: '0px',
    bottom: '20%',
  },
  xAxis: {
    show: false,
    type: 'category',
    boundaryGap: false,
  },
  yAxis: {
    show: false,
    type: 'value',
    min: val => val.min * 0.99,
    max: val => val.max * 1.01,
  },
  series: [
    {
      type: 'line',
      smooth: true,
      smoothMonotone: 'x',
      showSymbol: true,
      symbol: 'circle', // 这个把节点的空心圆换成实心圆
      symbolSize: 4, // 节点大小，数字随意，跟下面的线宽一样或少 1 像素
      lineStyle: {
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: '#FFFFFF',
            },
            {
              offset: 1,
              // color: '#5FB9FF',
              color: '#FFFFFF',

            },
          ],
          global: false, // 缺省为 false
        },
        width: 4,
      },
      itemStyle: {
        opacity: 1,
        color: '#fff',
      },
      label: {
        show: true,
        color: '#fff',
        formatter(params) {
          return params.data !== 0 ? `${params.data}%` : 0;
        },
      },
      areaStyle: {
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: 'rgba(95, 185, 255, 0.45)', // 100% 处的颜色
            },
            {
              offset: 1,
              color: 'rgba(95, 185, 255, 0.06)', // 0% 处的颜色
            },
          ],
          global: false, // 缺省为 false
        },
      },
    },
  ],
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      label: {
        show: true,
        backgroundColor: 'none',
        color: '#fff',
        fontFamily: 'DINAlternateBold',
        fontWeight: 700,
        fontSize: '12px',
      },
      lineStyle: {
        // color: '#5FB9FF',
        color: '#FFFFFF',
        opacity: '0.58',
        type: 'solid',
      },
    },
    backgroundColor: 'unset',
    borderWidth: 0,
    formatter: params => `${formatThousand(params[0].value)}%`,
    textStyle: {
      // color: '#5FB9FF',
      color: '#FFFFFF',
      fontSize: 12,
      fontWeight: 700,
      fontFamily: 'DINAlternateBold',
    },
    extraCssText: 'box-shadow: unset;',
    position: mp => [mp[0] - 20, mp[1] - 25],
  },
});
